import * as yup from 'yup';
import emptyStringToNull from './emptyStringToNull'

const maxDate = new Date(2100, 11, 31);

export default function afterDate(message) {
  return (st, schema) => {
    return st
      ? yup.date()
        .transform(emptyStringToNull)
        .nullable()
        .min(st, message)
        .max(maxDate, `Date must be before ${maxDate.toDateString()}`)
      : schema
  }
}
